const rootPath = '/img/png/icons';

const iconsPng = {
  eyeClosed: `${rootPath}/eye-closed.png`,
  eyeOpened: `${rootPath}/eye-opened.png`,
  lock: `${rootPath}/lock.png`,
  info: `${rootPath}/info.png`,
  redX: `${rootPath}/red-x.png`,
  addMember: `${rootPath}/add-member.png`,
  orangeExclamationMark: `${rootPath}/orange-exclamation.png`,
  screener: `${rootPath}/screener.png`,
  topRightBackground: `${rootPath}/signup-top-right-background-circle.png`,
  observations: `${rootPath}/observations.png`,
  personReading: `${rootPath}/person-reading.png`,
  handshake: `${rootPath}/handshake.png`,
  addProvider: `${rootPath}/add-provider.png`,
  locationPin: `${rootPath}/location-pin.png`,
  whiteExclamationOnPurpleTriangle: `${rootPath}/white-exclamation-on-purple-triangle.png`,
  wellnessDomainsPurple: {
    fun: `${rootPath}/wellness-domains-purple/fun.png`,
    vocational: `${rootPath}/wellness-domains-purple/vocational.png`,
    spiritual: `${rootPath}/wellness-domains-purple/spiritual.png`,
    mental: `${rootPath}/wellness-domains-purple/mental.png`,
    physical: `${rootPath}/wellness-domains-purple/physical.png`,
    purpose: `${rootPath}/wellness-domains-purple/purpose.png`,
    social: `${rootPath}/wellness-domains-purple/social.png`,
    readiness: `${rootPath}/wellness-domains-purple/readiness.png`,
    readinessWhite: `${rootPath}/wellness-domains-purple/readiness-white.png`,
  },
};

export default iconsPng;
